import { AddOn, PlanDetails } from './types'
import { Currency } from 'src/graphql'

export const GS_AFFILIATE_ID = 'GS00001'
const PROMPTING_U_MONTHLY_ID = 'PU00001'
const PROMPTING_U_ANNUAL_ID = 'PU00002'
const STREAM_MARKETING_ID = 'SM00001'
const STREAM_MARKETING_ID_2 = 'price_1IVQ0OASHJWgnbKEr8DpErh7'
const STREAM_VA_ID = 'SV00004'
const STREAM_VA_BASIC_ID = 'SV00005'
const STREAM_VA_PRO_ID = 'SV00006'
const ENHANCED_STRIPE_ID = '13705'
const CARDADAY_STRIPE_ID = '14547'
const UNLIMITED_STRIPE_ID = '13706'
export const UNLIMITED_100_STRIPE_ID = '13707'
export const UNLIMITED_250_STRIPE_ID = '14866'

export const SOC_SKUS = [
  GS_AFFILIATE_ID,
  ENHANCED_STRIPE_ID,
  CARDADAY_STRIPE_ID,
  UNLIMITED_STRIPE_ID,
  UNLIMITED_100_STRIPE_ID,
  UNLIMITED_250_STRIPE_ID,
  'legacy',
]
export const PROMPTING_U_SKUS = [PROMPTING_U_ANNUAL_ID, PROMPTING_U_MONTHLY_ID]
export const STREAM_VA_SKUS = [
  STREAM_VA_ID,
  STREAM_VA_BASIC_ID,
  STREAM_VA_PRO_ID,
]
export const STREAM_MARKETING_SKUS = [
  STREAM_MARKETING_ID,
  STREAM_MARKETING_ID_2,
]

export const SENDOGO_RP_STRIPE_ID = '14528'

const ELITE_STRIPE_ID = '14233'
export const ELITE_PLUS_STRIPE_ID = '14234'
const SYSTEM_SEND_STRIPE_ID = '14535'

export const ELITE_PACKAGES = [ELITE_STRIPE_ID, ELITE_PLUS_STRIPE_ID]
export const ADDON_PACKAGES = [...ELITE_PACKAGES, SYSTEM_SEND_STRIPE_ID]
export const ELITE_ELIGIBLE_PLANS = [
  ENHANCED_STRIPE_ID,
  CARDADAY_STRIPE_ID,
  UNLIMITED_STRIPE_ID,
  UNLIMITED_100_STRIPE_ID,
  UNLIMITED_250_STRIPE_ID,
]

export const COUPONS = {
  FREE_CAMPAIGN: 'ELITE_FREE_CAMPAIGN_COUPON',
}

export const PLAN_SKUS = {
  limited: 'Basic',
  [ENHANCED_STRIPE_ID]: 'Enhanced',
  [CARDADAY_STRIPE_ID]: 'Card A Day',
  [UNLIMITED_STRIPE_ID]: 'Unlimited',
  [UNLIMITED_100_STRIPE_ID]: 'Unlimited +100',
  [UNLIMITED_250_STRIPE_ID]: 'Unlimited +250',
  legacy: 'Legacy',
}

export const asSku = (value: string) => {
  switch (value) {
    case 'limited':
    case 'legacy':
    case ENHANCED_STRIPE_ID:
    case CARDADAY_STRIPE_ID:
    case UNLIMITED_STRIPE_ID:
    case UNLIMITED_100_STRIPE_ID:
    case UNLIMITED_250_STRIPE_ID:
      return value
    default:
      return undefined
  }
}

export const PLAN_ORDER = [
  'Basic',
  'Enhanced',
  'Card A Day',
  'Unlimited',
  'Unlimited +100',
  'Unlimited +250',
  'Premium',
  'Enterprise',
]

export const addOns: AddOn[] = [
  {
    id: '14535',
    title: 'System',
    subtitle: '',
    price: {
      amount: 39500,
      currency: Currency.USD,
      description: '$395.00 + tax',
    },
    billingInterval: '300 system cards',
    color: 'pink',
    stripeId: '14535',
    backgroundStartColor: '#F237EF',
    backgroundEndColor: '#FC5252',
    backgroundImageUrl: '',
    features: [
      {
        title:
          '300 Touches to use towards system card sends (*postage not included)',
      },
      { title: 'Unlimited Access to the Campaign Store' },
      { title: '12 months to use' },
      { title: 'Must be on a Subscription Plan to purchase' },
    ],
  },
]

export const planDetails: PlanDetails[] = [
  {
    plan: 'Basic',
    details: [
      { detail: '$2.75/Heartfelt Prompting Cards**' },
      {
        detail: 'Automated Sends*** tiered pricing:',
        innerDetails: [
          { detail: '$2.75 per card' },
          { detail: '$2.50 per card for 25+' },
          { detail: '$2.25 per card for 50+' },
          { detail: '$2.00 per card for 100+' },
        ],
      },
      { detail: 'Full retail price on gifts' },
      { detail: 'Enhanced Storage' },
    ],
  },
  {
    plan: 'Card A Day',
    details: [
      { detail: '30 Heartfelt Prompting Cards every month**' },
      { detail: '$2.00 per card beyond 30 Heartfelt Prompting Cards' },
      {
        detail: 'Automated Sends*** tiered pricing:',
        innerDetails: [
          { detail: '$2.00 per card' },
          { detail: '$1.85 per card for 25+' },
          { detail: '$1.70 per card for 50+' },
          { detail: '$1.55 per card for 100+' },
        ],
      },
      { detail: '20 percent discount on gifts*' },
      { detail: 'Enhanced storage' },
    ],
  },
  {
    plan: 'Unlimited',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards** (Postage included!)' },
      {
        detail: 'Automated Sends*** tiered pricing:',
        innerDetails: [
          { detail: '$1.75 per card' },
          { detail: '$1.60 per card for 25+' },
          { detail: '$1.45 per card for 50+' },
          { detail: '$1.30 per card for 100+' },
        ],
      },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premium storage' },
    ],
  },
  {
    plan: 'Unlimited +100',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards** (Postage included!)' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '100 Automated Sends***' },
      {
        detail: '$1.25 per additional Automated Send (postage not included)***',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premium Storage' },
    ],
  },
  {
    plan: 'Unlimited +250',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards** (Postage included!)' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '250 Automated Sends***' },
      {
        detail: '$1.00 per additional Automated Send (postage not included)***',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premium Storage' },
    ],
  },
]
